import {
  getUrlParamsFetch,
  handleAxiosError,
  urlBackend,
} from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { UseFetchEnabledParams, UseMutationsParams } from '@/shared/interfaces';
import { IProductoServicio, IProductoServicioForm, IProductoServicioResp, ProductoServicioParam } from '@/shared/interfaces/erp/administration/producto_servicio.interface';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const { get, post, put } = erpApi();


///* crear servicio
export const useFetchPostProductoServicio = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: postProductoServicio,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['servicio'] });

      if (data.code == 200) {
        navigate && returnUrl && navigate(returnUrl);
      }

      setAlert(true, data.message, data.status);
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

export const postProductoServicio = async (data: IProductoServicioForm) => {
  const resp = await post<IProductoServicio>(
    `${urlBackend}api/v1/servicio/`,
    data,
    true
  );
  return resp;
};


///* obtener los servicios

export const useFetchGetProductoServicio = ({
  params,
  enabled = true
}: UseFetchEnabledParams<ProductoServicioParam>) => {
  return useQuery({
    queryKey: ['servicio', ...Object.values(params || {})],
    queryFn: async () => {
      return await getProductoServicio(params);
    },
    retry: false,
    enabled,
  });
};

export const getProductoServicio = async (params?: ProductoServicioParam) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<IProductoServicioResp>(
    `${urlBackend}api/v1/servicio/?${queryParams}`,
    true
  );

  return resp;
};


///* obtener servicio por id
export const useFetchGetProductoServicioById = (id: string, enabled = false) => {
  return useQuery({
    queryKey: ['servicio', id],
    queryFn: async () => {
      return await getProductoServicioById(id);
    },
    enabled: enabled,
  });
};

export const getProductoServicioById = async (id: string) => {
  const resp = await get<IProductoServicio>(
    `${urlBackend}api/v1/servicio/${id}`,
    true
  );

  return resp.data;
};


///* actualizar servicio
interface IPutProducto { id: string; data: IProductoServicioForm }
export const useFetchPutProductoServicio = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async (data: IPutProducto) => {
      return putProductoServicio(data);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['servicio'] });

      if (data.code == 200) {
        navigate && returnUrl && navigate(returnUrl);
      }

      setAlert(true, data.message, data.status);
    },
  });
};

export const putProductoServicio = async ({ id, data }: IPutProducto) => {
  const resp = await put<IProductoServicio>(
    `${urlBackend}api/v1/servicio/${id}/`,
    data,
    true
  );

  return resp;
};
